import { configureStore } from '@reduxjs/toolkit';
import mapScreenReducer from '../../pages/Map/store/mapScreenSlce'

const store = configureStore({
  reducer: {
    mapScreen: mapScreenReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;